import React from 'react';

const Vk = () => (
  <svg
    width="22"
    height="13"
    viewBox="0 0 22 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.499.882c.15-.508 0-.882-.727-.882h-2.406c-.613 0-.894.32-1.045.678 0 0-1.226 2.97-2.957 4.896-.56.556-.817.735-1.123.735-.152 0-.384-.179-.384-.687V.882c0-.61-.172-.882-.678-.882H8.397c-.384 0-.613.284-.613.548 0 .577.866.711.956 2.336v3.527c0 .772-.139.914-.445.914-.817 0-2.802-2.982-3.978-6.395C4.08.268 3.847 0 3.23 0H.825C.139 0 0 .32 0 .678c0 .634.817 3.783 3.802 7.943C5.792 11.46 8.592 13 11.142 13c1.53 0 1.719-.341 1.719-.93 0-2.714-.14-2.97.629-2.97.355 0 .968.179 2.397 1.548C17.521 12.273 17.79 13 18.705 13h2.406c.686 0 1.033-.341.833-1.016-.458-1.417-3.55-4.334-3.688-4.53-.355-.454-.253-.657 0-1.064.004-.004 2.94-4.115 3.243-5.508z"
      fill="currentColor"
    />
  </svg>
);

export default Vk;
